export default {
      id: "icon--price-tag-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--price-tag-small-usage",
      toString: function () {
        return this.url;
      }
    }